export default "__VITE_ASSET__CpsLzJ3x__"